/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const BackOfficeTx2Status2 = {
    RESERVED: 'RESERVED',
    SETTLED: 'SETTLED',
    CANCELLED: 'CANCELLED',
    REJECTED: 'REJECTED',
    UNKNOWN: 'UNKNOWN'
} as const;

export type BackOfficeTx2Status2 = typeof BackOfficeTx2Status2[keyof typeof BackOfficeTx2Status2];



